import { takeEvery, fork, put, all, call } from "redux-saga/effects"


import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"


import {
  forgotPasswordUrl,
} from "../../../helpers/fakebackend_helper"

function* onForgotPassword(email) {
  try {
    const response = yield call(forgotPasswordUrl, {email: email.payload});
    yield put(userForgetPasswordSuccess(response.message));
  } catch (error) {
    yield put(userForgetPasswordError(error.response.data.message));
  }
}

function* forgetPasswordSaga() {
  yield takeEvery(FORGET_PASSWORD, onForgotPassword);
}
export default forgetPasswordSaga
